import { Util,Request } from "@xt/xtbase";
import { getOrigin1 } from "@/utils/method"

const { getOrigin } = Util;
const { XtAxios4, XtAxios } = Request;

const URL = getOrigin("www") + "/rfapi";


//合伙人排行榜
export function get_partnerRank(config) {
  return XtAxios.get(URL + `/public/partner/rank`, config);
}

//合伙人申请查询
export function get_channelApply(config) {
  return XtAxios.get(URL + `/partner/channel/apply`, config);
}

//合伙人等级列表
export function get_partnerLevel(config) {
  return XtAxios.get(URL + `/public/commission-level/partner-level`, config);
}

//合伙人申请
export function post_channelApply(config) {
  return XtAxios.post(URL + `/partner/channel/apply`, null, config);
}

//查询用户是否被邀请
export function get_applyStatus(config) {
  return XtAxios.get(URL + `/partner/apply`, config);
}

//添加直客或者合伙人回调接口
export function put_applyCallback(config) {
  return XtAxios.put(URL + `/partner/apply/callback`, null, config);
}

//KYC国家
export function get_countryInfos(config) {
  return XtAxios.get(getOrigin("www") + `/uaapi/user/user/country/countryInfos`, config);
}



